const form = `
    <div class="wizard-progress" id="{{ wizardKey }}-header" ref="{{ wizardKey }}-header">
      <div
        class="wizard-progress-completed"
        style="transform: translateX({{ (currentPage * 100) / panels.length - 100 }}%);"
      ></div>
    </div>
`;

export default form;
